<template>
  <div class="mt-5">
    <!-- <div class="vx-row mb-5">
      <div class="vx-col w-1/1 text-center">
        <div class="datepicker-main">
            <div class="datewrapper">
                <label for class="float-right w-auto">Select Week Date</label>
                <datepicker :calendar-button="true" calendar-button-icon="fa fa-calendar"
                    placeholder="Select Date"
                    class="float-right calendar-icon-right top-45"
                    format="dd/MM/yyyy"
                    v-model="current_date"
                    @change="dateweek()"
                    :disabledDates="disabledDates"
                ></datepicker>
            </div>
        </div>
      </div>
    </div> -->
    <div class="vx-row mb-5" v-if="!active_user_id && !active_user_name">
      <div :class="'vx-col w-full'">
        <vs-list  >
          <vs-list-item :title="(user.firstname+' '+user.lastname) | capitalize" :subtitle="user.designation" @click.native="getUserActivityDetails(user._id,user.firstname,user.lastname,user.department?user.department.department_name:'',user.office?user.office.office_name:'')" :key="uindex" v-for="(user,uindex) in all_users">
            <template slot="avatar">
              <vs-avatar class="" :src="user.profile_image" size="40px" v-if="user.profile_image"/>
              <vs-avatar color="primary" class="name-avatar" :text="usernameList(user.firstname,user.lastname)" size="40px" v-else />
            </template>
          </vs-list-item>
        </vs-list>
      </div>
    </div>
    <div v-else>
      <div class="flex flex-wrap items-center email-header justify-between sm:pb-2">
        <div class="flex mb-4">
          <div class="flex items-center">
            <feather-icon icon="ArrowLeftIcon" @click="clearArray()" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
            <h3 >{{ active_user_name | capitalize }}</h3>
          </div>
        </div>
        <!-- <div class="ml-10 mb-4 mt-1">
          <div class="email__actions--single flex items-baseline">
            <vue-json-to-csv :json-data="[]" :csv-title="active_user_name+'-activity-data'">
              <vs-button :disabled="!activity_data && !activity_data.dayWiseData.length" class="gradient-btn">
                <feather-icon icon="DownloadIcon" title="Download CSV" class></feather-icon> CSV
              </vs-button>
            </vue-json-to-csv>
            <vs-button
              :disabled="!activity_data && !activity_data.dayWiseData.length"
              class="ml-1 gradient-btn"
              title="Download PDFs"
              @click.prevent="generatePDF"
            >
              <feather-icon icon="FileTextIcon" class></feather-icon> PDF
            </vs-button>            
          </div>
        </div> -->
      </div>
      <div class="vx-row mb-5" :key="w_index" v-for="(week_data,w_index) in activity_data.dayWiseData" >
        <div class="vx-col w-full m-auto" v-if="week_data.inoutData.length">
          <h4 class="m-2">{{convertDate(week_data.date)}}</h4>
          <vs-table class="" :data="manageTimeArray(week_data.date,week_data.inoutData)" :disabled="true">
            <template slot="thead">
              <vs-th class="sticky-col user-col">Status</vs-th>
              <vs-th class="sticky-col user-col">Time</vs-th>
              <vs-th class="sticky-col user-col">Notes</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="sticky-col user-col">{{ manageStatus(tr.main_status,tr.status,tr.is_clockedIn,tr.is_clockedOut) }}</vs-td>
                <vs-td class="sticky-col user-col">{{ tr.start_time | moment('hh:mm a') }}</vs-td>
                <vs-td class="sticky-col user-col">{{ tr.comment }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
        <div v-else class="vx-col w-full m-auto">
          <div v-if="checkDate(week_data.date)">
           <h4 class="m-2">{{convertDate(week_data.date)}}</h4>
             <vs-table class="" :data="week_data.inoutData" :disabled="true">
            <template slot="thead">
              <vs-th class="sticky-col user-col">Status</vs-th>
              <vs-th class="sticky-col user-col">Time</vs-th>
              <vs-th class="sticky-col user-col">Notes</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="sticky-col user-col">{{ manageStatus(tr.main_status,tr.status,tr.is_clockedIn,tr.is_clockedOut) }}</vs-td>
                <vs-td class="sticky-col user-col">{{ tr.start_time | moment('hh:mm a') }}</vs-td>
                <vs-td class="sticky-col user-col">{{ tr.comment }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
          </div>
        </div>
        <div class="vx-col w-full m-auto mt-8" v-if="week_data.inoutData.length">
          <vs-table class="" :data="week_data.inoutData" :disabled="true">
            <template>
              <vs-tr>
                <vs-th>Total Time</vs-th>
                <vs-td class="sticky-col user-col center-col"></vs-td>
                <vs-td class="sticky-col user-col">{{ covertToTime(week_data.totalActiveTimeInMiliSeconds + week_data.totalOutInMilliSeconds) }} hrs worked</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th>Break/s</vs-th>
                <vs-td class="sticky-col user-col center-col"></vs-td>
                <vs-td class="sticky-col user-col">{{covertToTime(week_data.totalBreakTimeInMiliSeconds) }} hrs worked</vs-td>
              </vs-tr>
              <!-- <vs-tr>
                <vs-th>In</vs-th>
                <vs-td class="sticky-col user-col center-col">4.5 hrs</vs-td>
                <vs-td class="sticky-col user-col bg-success">55% IN</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th>OUT</vs-th>
                <vs-td class="sticky-col user-col center-col">4 hrs</vs-td>
                <vs-td class="sticky-col user-col bg-warning">45% OUT</vs-td>
              </vs-tr> -->
            </template>
          </vs-table>
        </div>
        <div v-else class="vx-col w-full m-auto">
         <div v-if="checkDate(week_data.date)">
            <table width="100%" :data="week_data.inoutData" :disabled="true">
              <tr>
                <th>Total Time</th>
                <td class="sticky-col user-col center-col"></td>
                <td class="sticky-col user-col">00:00 hrs worked</td>
              </tr>
              <tr>
                <th>Break/s</th>
                <td class="sticky-col user-col center-col"></td>
                <td class="sticky-col user-col">00:00 hrs worked</td>
              </tr>
              <!-- <vs-tr>
                <vs-th>In</vs-th>
                <vs-td class="sticky-col user-col center-col">4.5 hrs</vs-td>
                <vs-td class="sticky-col user-col bg-success">55% IN</vs-td>
              </vs-tr>
              <vs-tr>
                <vs-th>OUT</vs-th>
                <vs-td class="sticky-col user-col center-col">4 hrs</vs-td>
                <vs-td class="sticky-col user-col bg-warning">45% OUT</vs-td>
              </vs-tr> -->
           
          </table>
          </div>
        </div>
      </div>
      <div class="printweeklypdf hidden" id="printweeklypdf">
        <!-- <table width="100%" style="width:100%;border-collapse: collapse;border:0;" id="titlePdf">
            <tbody>
              <tr style="border-collapse: collapse;border:0;">
                  <td style="min-width:90px;max-width:90px;letter-spacing: 0px;color:#000;font-size:5px;border: 0px;border-collapse: collapse;">Weekly Activity Log</td>
              </tr>
            </tbody>
          </table> -->
           <table width="100%" id="pdfHeader">
            <tbody>
               <tr >
                  <td >Weekly Activity Log</td>
                  <td >{{ $store.state.uInfo.org_name }}</td>
              </tr>
            <tr >
              
              <td  colspan="2">User: <span>{{ active_user_name }}</span></td>
            </tr>
            <tr >
              <td >Office: {{ active_user_office }} </td> 
              <td >Department: {{ active_user_department }}</td>
            </tr >
            <tr style="border-collapse: collapse;">
              <td  colspan="2">Date: <span>{{ WeekDates }}</span></td>
            </tr>
            </tbody>
          </table>
           <div :key="w_index" style="width:100%" v-for="(week_data,w_index) in activity_data.dayWiseData" >
            <div v-if="week_data.inoutData.length" style="width:100%">
             <table width="100%" :id="'printPdf_'+w_index">
              <thead v-if="w_index ==0">
              <tr  style="border-collapse: collapse;border:0;" align="left">
                  <th >Status</th>
                  <th  >Time</th>
                  <th  >Notes</th>
              </tr>
              </thead>
               <tbody>
                <tr align="left" v-if="manageTimeArray(week_data.date,week_data.inoutData).length" >
                  <td 
                  colspan="3" >{{ convertDatePDF(week_data.date) }}</td>
                </tr>
                <tr align="left" :key="indextr" v-for="(tr, indextr) in manageTimeArray(week_data.date,week_data.inoutData)">
                  <td  >{{ manageStatus(tr.main_status,tr.status,tr.is_clockedIn,tr.is_clockedOut) }}</td>
                  <td  >{{ tr.start_time | moment('timezone',$store.state.uInfo.timeZone, 'hh:mm A') }} </td>
                  <td  >{{ tr.comment }}</td>
                </tr>
               </tbody>
            </table>
          </div>
       
        </div>
           <table id="pdfFooter" >
           <tr >
                <th >Total Time</th>
                <td>{{total_active_time || '00.00' }} hrs worked</td>
              </tr>
              <tr >
                <th >Break/s</th>
                <td>{{total_break_time || '00.00' }} hrs worked</td>
              </tr> 
          </table>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/mixins/mixin.js';
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import VueJsonToCsv from "vue-json-to-csv";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable'
export default {
  components: {
    Datepicker,
    jsPDF,
    "vue-json-to-csv": VueJsonToCsv,
    EventBus
  },
  props: {
    office_id: {
      required: false,
      default: 'all',
      type: String
    },
    department_id: {
      required: false,
      default: 'all',
      type: Array
    },
    search: {
      required: false,
      default: '',
      type: String
    },
     current_date: {
      required: true,
      default: new Date(),
    },
  },
  data() {
    return {
      timezone: this.$store.state.uInfo.timeZone,
      perPage: 25,
      totalPage: 1,
      currentPage: 1,
      all_users: [],
      active_user_id: null,
      activity_data: [],
      //current_date: new Date(),
      format: "dd/MM/yyyy",
      csvData: [],
      disabledDates: {
        from: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() + 1
        ) // Disable all dates after specific date
      },
      total_active_time: null,
      total_break_time: null,
      active_first_name:'',
      active_last_name:'',
      active_user_name: '',
      active_user_department:'',
      active_user_office:'',
      WeekDates:'',
      weekStartDay:"",
    };
  },
  watch:{
    office_id(nv) {
      // if (nv) {
        this.getusers();
      // }
    },
    department_id(nv) {
      //if (nv) {
        this.getusers();
     // }
    },
    currentPage(nv) {
      if (nv) {
        this.getusers();
      }
    },
    perPage(nv) {
      if (nv) {
        this.getusers();
      }
    },
    current_date(nv) {
      if (nv) {
        this.getusers();
        this.getDateTimeData();
        if(this.active_user_id && this.active_user_name){
          this.getUserActivityDetails(this.active_user_id,this.active_first_name,this.active_last_name,this.active_user_office,this.active_user_department);
        }
      }
    },
    search(nv){
    //  if (nv && nv.length > 3) {
        this.getusers();
     // }
    }
  },
  created() {
  },
  mounted() {
    this.getusers();
    this.getDateTimeData();
    EventBus.$on("dayWeekTimeAcitivityPDF", () => {
        this.generatePDF();
    });
  },
  computed: {
  },
  methods: {
    checkDate(date){
      let checkDate = moment(date).format("DD/MM/YYYY");
      let today = moment().format("DD/MM/YYYY");
      return checkDate > today?false:true;
    },
    getDateTimeData() {
      this.$vs.loading({ color: "primary" });

      let url = "oinfo/getInfo";
      this.axios
        .get(url)
        .then(response => {
          this.$vs.loading.close();
          let data = response.data.data;
          this.weekStartDay = data.week_start_day;
          let startDay = data.week_start_day;
          let endDay = data.week_end_day;        
          let daysWorking = [{day:0,name:'Su',fullname:"Sunday"},{day:1,name:'Mo',fullname:"Monday"},{day:2,name:'Tu',fullname:"Tuesday"},{day:3,name:'We',fullname:"Wednesday"},{day:4,name:'Th',fullname:'Thursday'},{day:5,name:'Fr',fullname:'Friday'},{day:6,name:'Sa',fullname:"Saturday"}];
           let startworkingday = daysWorking.find( ({ name }) => name === startDay );
           let endworkingday = daysWorking.find( ({ name }) => name === endDay );
          let startArr = [];
          let endArr = [];
         for (let index = 0; index < daysWorking.length; index++) {
           if(startworkingday.day  > endworkingday.day) {
             if(index >= startworkingday.day){
               startArr.push(daysWorking[index].fullname);
                }
                if(index <= endworkingday.day){
                  endArr.push(daysWorking[index].fullname);
                }
              }
            else {
              if(startworkingday.day <=index && endworkingday.day >=index){
                startArr.push(daysWorking[index].fullname);
              }  
            }
          }
          this.workingDaysArr =  startArr.concat(endArr);
          let days =["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
          var difference = days.filter(x => !this.workingDaysArr.includes(x));
          difference.forEach(element => {
            this.workingDaysArr.push(element);
          });
          let date = this.current_date;
          let result = [];
          let selectedDayIndex = moment(date).isoWeekday();
          let workIndex = days.indexOf(this.workingDaysArr[0]);
          if(selectedDayIndex >= workIndex){
            let s = moment(date).isoWeekday(this.workingDaysArr[0]);
            let addDate = moment(date).isoWeekday(this.workingDaysArr[0]);
            for (let i = 1; i <= 7; i++) {
            //let s = moment(date).isoWeekday(this.workingDaysArr[i-1]);
            result.push({
              Date: moment(s).format("MMM DD"),
              Day: moment(s).format("ddd"),
              fullDate :moment(s).format("DD/MM/YYYY")
            });
            s = moment(addDate, "DD/MM/YYYY").add(i, 'days');
            }  
          } else {
            let s = moment(date).isoWeekday(this.workingDaysArr[0]);
            let addDate = moment(date).isoWeekday(this.workingDaysArr[0]);
            for (let i = 1; i <= 7; i++) {
              //let s = moment(date).isoWeekday(this.workingDaysArr[i-1]);
                s = moment(addDate, "DD/MM/YYYY").subtract(i, 'days');
              result.push({
                Date: moment(s).format("MMM DD"),
                Day: moment(s).format("ddd"),
                fullDate :moment(s).format("DD/MM/YYYY")
              });
          }
          result = result.reverse();
          }
          this.WeekDatesstr = result[0].fullDate+'-'+result[result.length - 1].fullDate;
          this.WeekDates = result;
          this.getWeeklyTimeSheet();
        })
        .catch(e => {
          this.showError(e);
        });
    },
     dateweek() {
      let date = this.current_date;
      let fd = moment(date).isoWeekday(1);
      let ld = moment(date).isoWeekday(7);
       this.WeekDates = moment(fd).format("DD/MM/YYYY")+'-'+moment(ld).format("DD/MM/YYYY");
     
    },
     convertDatePDF(date){
       return moment.tz(date, this.timezone).format('Do MMM YY');
    },
    checkCurrentDate(c_date,start_time){
      let current = moment(c_date).format("DD/MM/YYYY");
      let start_date = moment(start_time).format("DD/MM/YYYY");
      if (current == start_date) {
        return true;
      }else{
        return false;
      }
    },
    manageTimeArray(c_date,time_arr){
      let custom_arr = [];
      time_arr.forEach(element => {
        let current = moment(c_date).format("DD/MM/YYYY");
        let start_date = moment(element.start_time).format("DD/MM/YYYY");
        if (current == start_date) {
          custom_arr.push(element);
        }
      });
      return custom_arr;
    },
    convertDate(date){
      return moment.tz(date, this.timezone).format('DD/MM/YYYY');
    },
    // Manage status
    manageStatus(main_status,status,is_clockedIn,is_clockedOut){
      let text = '';
      if (main_status == 'CIN' && status == 'IN' && is_clockedIn) {
        text = 'Clock On';
      } 
      else if (main_status == 'CIN' && status == 'IN' && !is_clockedIn) {
        text = 'In';
      } 
      else if (main_status == 'COUT' && status == 'OUT') {
        text = 'Clock Off';
      }
      else if (main_status == 'CIN' && status == 'BI') {
        text = 'Break Start';
      } 
      else if (main_status == 'CIN' && status == 'BS') {
        text = 'Break End';
      }
      else if (main_status == 'CIN' && status == 'OUT') {
        text = 'Out';
      }
      return text;
    },
    /** set avatar name */
    usernameList(firstname, lastname) {
      if (firstname && lastname) {
        let first = firstname.trim().charAt(0);
        let last = lastname.trim().charAt(0);
        let name = first.concat(last);
        return name.toUpperCase();
      }
    }, 
    // ===== Get User List =====
    async getusers() {
      this.$vs.loading({ color: "primary" });

      let url = "user/getOrganizationalUser?1=1";
      if (this.search) {
        url += '&search='+this.search;
      }
      if (this.office_id) {
        let office = this.office_id ? this.office_id : 'all';
        url += "&office="+office;
      }
      if (this.department_id) {
        let department = this.department_id ? this.department_id.toString() : 'all'
        url += "&department="+department;
      }
      return await this.axios
        .get(url)
        .then(response => {
          let data = response.data.data;
          this.all_users = data;
          this.$vs.loading.close();
          return true;
        })
        .catch(e => {
          this.showError(e);
          return false;
        });
    }, 
    // Get user Activty Details
    async getUserActivityDetails(user_id = null,firstname='',lastname='',departmentname='',officename=''){
      // if (this.active_user_id && this.active_user_id == user_id) {
      //   this.clearArray();
      //   return
      // }else{
        this.active_user_id = user_id;
        this.active_user_name = firstname+' '+lastname;
        this.active_user_department = departmentname;
        this.active_user_office = officename;
        this.active_first_name = firstname;
        this.active_last_name = lastname;
      //}
      if (!user_id) {
        this.$vs.notify({
          text: 'User not found. please select user!',
          color: "danger",
          position: "top-right"
        });
      }
      this.$vs.loading({ color: "primary" });
      let input = {
        timeZone: this.timezone,
        date: moment.tz(this.current_date, this.timezone).format('DD/MM/YYYY'),
        user_id: user_id,
        week_start_day:this.weekStartDay
      };
      return await this.axios
        .post('timesheet/getUserWeeklyTimeSheetData',input)
        .then(response => {
          if (response.data && response.data.status == 200 && response.data.data) {
            let data = response.data.data;
            this.activity_data = data;
            this.total_active_time = this.covertToTime(data.totalActiveTimeInMiliSeconds+data.totalOutInMilliSeconds);
            this.total_break_time = this.covertToTime(data.totalBreakTimeInMiliSeconds);
             EventBus.$emit('showButton', true);
            let csvData = [];
            if (this.activity_data && this.activity_data.dayWiseData.length != 0) {
              let that = this;
              this.activity_data.dayWiseData.forEach(data => {
                  data.inoutData.forEach(element => {
                    let new_obj = {
                      Date:  moment.tz(data.date, this.timezone).format('DD/MM/YYYY'),
                      User: this.active_user_name,
                      Status: this.manageStatus(element.main_status,element.status,element.is_clockedIn,element.is_clockedOut),
                      Time: moment.tz(element.start_time, this.timezone).format('hh:mm a'),
                      Comment: element.comment
                    }
                    csvData.push(new_obj);
                  }); 
              });
              this.csvData = csvData;
            } else {
              this.csvData = [];
            }
            this.$vs.loading.close();
            return true;
          }
        })
        .catch(e => {
          this.showError(e);
          return false;
        });
    },
    clearArray(){
      this.activity_data = [];
      this.active_user_id = null;
      this.active_user_name = null;
      this.total_active_time = null;
      this.total_break_time = null;
      this.active_user_office = '';
      this.active_user_department = '';
      this.active_first_name = '';
      this.active_last_name = '';
      this.csvData = [];
      EventBus.$emit('showButton', false);
    },
    getCSVData(){
      let csvData = [];
      if (this.activity_data && this.activity_data.dayWiseData.length != 0) {
        let that = this;
        this.activity_data.dayWiseData.forEach(data => {
            data.inoutData.forEach(element => {
              let new_obj = {
                Date:  moment.tz(data.date, this.timezone).format('DD/MM/YYYY'),
                User: this.active_user_name,
                Status: this.manageStatus(element.main_status,element.status,element.is_clockedIn,element.is_clockedOut),
                Time: moment.tz(element.start_time, this.timezone).format('DD/MM/YYYY'),
                Comment: element.comment
              }
              csvData.push(new_obj);
            });
        });
      }
      return csvData;
    },
    generatePDF(){
   
      let doc = new jsPDF()
        doc.text('Multiple tables', 14, 20)

        autoTable(doc, { html: '#pdfHeader' })
        let dt = this.activity_data;
        if(dt.dayWiseData){
        for (let index = 0; index < dt.dayWiseData.length; index++) {
          if(dt.dayWiseData[index].inoutData.length){
            autoTable(doc, { html: '#printPdf_'+index,
            columnStyles: {0:{cellWidth:'auto',minCellWidth:3},
               1: { halign: 'left', cellWidth:'auto',minCellWidth:3} },
               2:{cellWidth:'auto',minCellWidth:3} }
               )
          }
        }
        }
        autoTable(doc, { html: '#pdfFooter' })
        doc.save(this.active_user_name+"-activity-data.pdf")
    }
  },
  destroyed() {
    EventBus.$off('dayWeekTimeAcitivityPDF');
  },
};
</script>
<style>
.activity-collapse > .vs-collapse-item > .vs-collapse-item--header {
  padding: 0px !important;
}
.activity-collapse > .vs-collapse-item .open-item > .vs-collapse-item--content {
  max-height: 100% !important;
}
</style>